@if (!submitting() && submittingSuccess()) {
<app-review-success-step></app-review-success-step>
} @else {
<section [formGroup]="formGroup!" ngxsForm="codDetail.creditReviewForm">
    <h2 class="text-base font-bold text-font-primary">Credit Review</h2>
    <p class="text-xs text-font-secondary">Enter any missing information or update the existing information below.</p>
    <div class="max-w-input flex flex-col gap-2 mt-4">
        <sag-ui-input
            label="Confirm the value of the financial adjustment in EUR:"
            type="number"
            [step]="0.01"
            formControlName="financialAdjustment"
            ><span ngProjectAs="end-decorator" class="text-[#F3F3F0] pr-4 h-full flex items-center justify-center">
                €
            </span></sag-ui-input
        >
        <app-attachments-input controlName="creditReviewRelatedDocuments" [form]="formGroup!"></app-attachments-input>
    </div>
    @if (!disabled) {
    <sag-ui-button
        icon="checkmark-large"
        size="sm"
        class="mt-4"
        [disabled]="invalid"
        [loading]="submitting()"
        (click)="submit()"
        >Save</sag-ui-button
    >
    }
</section>
}
